var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-detail-blog"},[_c('v-md-editor',{attrs:{"height":"400px"},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }